
import React, { useState, useEffect, useContext, useRef } from "react";
import { getAllItems } from "../../actions/itemActions";
import { ItemContext } from "../../Context/ItemContext";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory, Link } from "react-router-dom";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import AddItem from "./addItem";
import Items from "./Items";
import Categories from "./Categories";
import usePermissions from "../../utils/permissions";
import PrintIcon from "@material-ui/icons/Print";
import ReactToPrint from "react-to-print";
import AllBarcodesPrint from "./AllBarcodesPrint";
import {
  Container,
  Grid,
  Button,
  Tabs,
  Tab,
  Typography,
  Box,
  TextField,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CategoryIcon from "@material-ui/icons/Category";
import ListIcon from "@material-ui/icons/List";
import ClearIcon from "@material-ui/icons/Clear";
import { getAllCategories } from "../../actions/categoryActions";
import EditIcon from "@material-ui/icons/Edit";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
// import ListIcon from "@material-ui/icons/List";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "calc(100% - 71px)",
    marginLeft: "71px",
    marginRight: 0,
    padding: theme.spacing(3),
    minHeight: "100vh",
    background:
      "linear-gradient(180deg, rgba(250,250,250,1) 0%, rgba(246,246,246,1) 100%)",
    boxSizing: "border-box",
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2.5),
    flexWrap: "wrap", // Responsive support
    gap: theme.spacing(2),
  },
  header: {
    fontWeight: 700,
    color: "#1f2d3d",
    letterSpacing: "-0.02em",
  },
  searchField: {
    width: "100%",
    minWidth: "260px",
    maxWidth: "340px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      minHeight: "56px",
      "& fieldset": {
        borderColor: "#e2e8f0",
      },
      "&:hover fieldset": {
        borderColor: "#ef7f1a",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#ef7f1a",
      },
    },
  },
  tabs: {
    borderBottom: "none",
    marginBottom: theme.spacing(2.5),
    backgroundColor: "#fff",
    borderRadius: "14px",
    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.06)",
    padding: "2px 8px",
  },
  tab: {
    textTransform: "none",
    minHeight: "54px",
    minWidth: "140px",
    fontWeight: 600,
    fontSize: "1rem",
    color: "#64748b",
    "&.Mui-selected": {
      color: "#ef7f1a",
    },
    transition: "color 0.2s ease-in-out",
  },
  actionButtons: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, max-content))",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
    alignItems: "stretch",
  },
  addButton: {
    backgroundColor: "#ef7f1a",
    color: "#fff",
    minHeight: "48px",
    padding: theme.spacing(1, 2.5),
    borderRadius: "10px",
    transition: "background-color 0.3s ease, transform 0.2s ease",
    "&:hover": {
      backgroundColor: "#d96f17",
      transform: "translateY(-2px)",
    },
    "&:disabled": {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    },
  },
  bulkButton: {
    borderColor: "#ef7f1a",
    color: "#ef7f1a",
    minHeight: "48px",
    padding: theme.spacing(1, 2.5),
    borderRadius: "10px",
    transition: "border-color 0.3s ease, color 0.3s ease, transform 0.2s ease",
    "&:hover": {
      borderColor: "#d96f17",
      color: "#d96f17",
      transform: "translateY(-2px)",
    },
    "&:disabled": {
      borderColor: "#ccc",
      color: "#ccc",
    },
  },
  printButton: {
    backgroundColor: "#1976d2",
    color: "#fff",
    minHeight: "48px",
    padding: theme.spacing(1, 2.5),
    borderRadius: "10px",
    transition: "background-color 0.3s ease, transform 0.2s ease",
    "&:hover": {
      backgroundColor: "#115293",
      transform: "translateY(-2px)",
    },
  },
  bulkEditButton: {
    borderColor: "#388e3c",
    color: "#388e3c",
    minHeight: "48px",
    padding: theme.spacing(1, 2.5),
    borderRadius: "10px",
    transition: "border-color 0.3s ease, color 0.3s ease, transform 0.2s ease",
    "&:hover": {
      borderColor: "#2e7d32",
      color: "#2e7d32",
      transform: "translateY(-2px)",
    },
    "&:disabled": {
      borderColor: "#ccc",
      color: "#ccc",
    },
  },
  noDataContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    backgroundColor: "#fff",
    borderRadius: "14px",
    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.06)",
    marginTop: theme.spacing(4),
    animation: "fadeIn 0.5s ease-in-out",
  },
  futurePriceButton: {
    borderColor: "#0288d1",
    color: "#0288d1",
    minHeight: "48px",
    padding: theme.spacing(1, 2.5),
    borderRadius: "10px",
    transition: "border-color 0.3s ease, color 0.3s ease, transform 0.2s ease",
    "&:hover": {
      borderColor: "#01579b",
      color: "#01579b",
      transform: "translateY(-2px)",
    },
    "&:disabled": {
      borderColor: "#ccc",
      color: "#ccc",
    },
  },
  futurePriceViewButton: {
    borderColor: "#7b1fa2",
    color: "#7b1fa2",
    minHeight: "48px",
    padding: theme.spacing(1, 2.5),
    borderRadius: "10px",
    transition: "border-color 0.3s ease, color 0.3s ease, transform 0.2s ease",
    "&:hover": {
      borderColor: "#4a0072",
      color: "#4a0072",
      transform: "translateY(-2px)",
    },
    "&:disabled": {
      borderColor: "#ccc",
      color: "#ccc",
    },
  },
  noDataText: {
    color: "#7f8c8d",
    textAlign: "center",
    marginTop: theme.spacing(2),
    fontSize: "1.1rem",
  },
  contentCard: {
    backgroundColor: "rgba(255,255,255,0.92)",
    borderRadius: "18px",
    boxShadow: "0 16px 36px rgba(15, 23, 42, 0.06)",
    padding: theme.spacing(2.5),
    backdropFilter: "blur(6px)",
    maxWidth: "1280px",
    margin: "0 auto",
  },
  tableWrap: {
    overflowX: "auto",
    borderRadius: "14px",
  },
  "@keyframes fadeIn": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
}));

const ItemsList = () => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const { itemId, setItemId } = useContext(ItemContext);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { items } = useSelector((state) => state.items);
  const isItemsLoading = useSelector((state) => state.items.isLoading);
  const { categories } = useSelector((state) => state.categories);
  const isCategoriesLoading = useSelector((state) => state.categories.isLoading);
  const compRef = useRef(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedOption, setSelectedOption] = useState(() => {
    return localStorage.getItem("selectedOption") || "Items";
  });

  const {
    loading: permissionsLoading,
    canUpdatePage,
    canDeletePage,
    canCreatePage,
    isAdmin,
  } = usePermissions();

  useEffect(() => {
    dispatch(getAllItems());
    dispatch(getAllCategories());
  }, [dispatch]);

  useEffect(() => {
    localStorage.setItem("selectedOption", selectedOption);
  }, [selectedOption]);

  if (!user) {
    history.push("/login");
  }

  const filteredItems = items.filter(
    (item) =>
      !item.isDeleted &&
      item.itemName &&
      typeof item.itemName === "string" &&
      item.itemName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const filteredCategories = categories.filter(
    (category) =>
      !category.isDeleted &&
      category.categoryName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleTabChange = (event, newValue) => {
    setSelectedOption(newValue);
  };

  const clearSearch = () => setSearchQuery("");

  return (
    <Container maxWidth={false} disableGutters className={classes.root}>
      <Box className={classes.contentCard}>
        <Grid container className={classes.headerContainer} alignItems="center">
          <Grid item xs={12} sm>
            <Typography variant="h5" className={classes.header}>
              Inventory Management
            </Typography>
          </Grid>
          <Grid item xs={12} sm="auto">
            <TextField
              className={classes.searchField}
              label="Search"
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton onClick={clearSearch} size="small">
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>

        <Tabs
          value={selectedOption}
          onChange={handleTabChange}
          className={classes.tabs}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="Items" value="Items" className={classes.tab} />
          <Tab label="Categories" value="Categories" className={classes.tab} />
        </Tabs>

        {isItemsLoading || isCategoriesLoading ? (
          <Spinner />
        ) : selectedOption === "Items" && filteredItems.length === 0 ? (
          <Box className={classes.noDataContainer}>
            <NoData />
            <Typography variant="body1" className={classes.noDataText}>
              {searchQuery
                ? "No results found for searched items."
                : "No items yet. Add your first item or upload in bulk!"}
            </Typography>
            {!searchQuery && (
              <Box className={classes.actionButtons}>
                <Button
                  variant="contained"
                  className={classes.addButton}
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setItemId(null);
                    setOpen(true);
                  }}
                >
                  Add Item
                </Button>
                <Link to="/bulk-upload">
                  <Button
                    variant="outlined"
                    className={classes.bulkButton}
                    startIcon={<CloudUploadIcon />}
                  >
                    Bulk Upload
                  </Button>
                </Link>
              </Box>
            )}
            <AddItem open={open} setOpen={setOpen} />
          </Box>
        ) : selectedOption === "Categories" && filteredCategories.length === 0 ? (
          <Box className={classes.noDataContainer}>
            <NoData />
            <Typography variant="body1" className={classes.noDataText}>
              {searchQuery
                ? "No results found for searched categories."
                : "No categories yet."}
            </Typography>
          </Box>
        ) : (
          <>
            {selectedOption === "Items" && (
              <Box>
                <Box className={classes.actionButtons}>
                  <Button
                    variant="contained"
                    className={classes.addButton}
                    startIcon={<AddIcon />}
                    onClick={() => {
                      setItemId(null);
                      setOpen(true);
                    }}
                    disabled={
                      permissionsLoading || (!isAdmin() && !canCreatePage("Items"))
                    }
                  >
                    Add Item
                  </Button>
                  <Link to="/bulk-upload">
                    <Button
                      variant="outlined"
                      className={classes.bulkButton}
                      startIcon={<CloudUploadIcon />}
                      disabled={
                        permissionsLoading ||
                        (!isAdmin() && !canCreatePage("Items"))
                      }
                    >
                      Bulk Upload
                    </Button>
                  </Link>

                  <Link to={{ pathname: "/bulk-edit", state: { selectedItems } }}>
                    <Button
                      variant="outlined"
                      className={classes.bulkEditButton}
                      startIcon={<EditIcon />}
                      disabled={
                        permissionsLoading ||
                        (!isAdmin() && !canUpdatePage("Items")) ||
                        selectedItems.length === 0
                      }
                    >
                      Bulk Edit ({selectedItems.length})
                    </Button>
                  </Link>
                  <Link
                    to={{ pathname: "/future-price-list", state: { selectedItems } }}
                  >
                    <Button
                      variant="outlined"
                      className={classes.futurePriceButton}
                      disabled={
                        permissionsLoading ||
                        (!isAdmin() && !canUpdatePage("Items")) ||
                        selectedItems.length === 0
                      }
                    >
                      Schedule Future Prices ({selectedItems.length})
                    </Button>
                  </Link>
                  <Link to="/future-price-list/view">
                    <Button
                      variant="outlined"
                      className={classes.futurePriceViewButton}
                      startIcon={<ListIcon />}
                      disabled={
                        permissionsLoading || (!isAdmin() && !canUpdatePage("Items"))
                      }
                    >
                      View Future Prices
                    </Button>
                  </Link>
                  <ReactToPrint
                    trigger={() => (
                      <Button
                        variant="contained"
                        className={classes.printButton}
                        startIcon={<PrintIcon />}
                      >
                        Print Barcodes
                      </Button>
                    )}
                    content={() => compRef.current}
                  />
                </Box>
                <AddItem
                  open={open}
                  setOpen={setOpen}
                  itemId={itemId}
                  setItemId={setItemId}
                />
                <Box className={classes.tableWrap}>
                  <Items
                    open={open}
                    setOpen={setOpen}
                    itemId={itemId}
                    setItemId={setItemId}
                    items={filteredItems}
                    canUpdate={canUpdatePage("Items")}
                    canDelete={canDeletePage("Items")}
                    permissionsLoading={permissionsLoading}
                    isAdmin={isAdmin()}
                    selectedItems={selectedItems}
                    setSelectedItems={setSelectedItems}
                  />
                </Box>
                <div style={{ display: "none" }}>
                  <AllBarcodesPrint items={filteredItems} ref={compRef} />
                </div>
              </Box>
            )}
            {selectedOption === "Categories" && (
              <Categories categories={filteredCategories} />
            )}
          </>
        )}
      </Box>
    </Container>
  );
};

export default ItemsList;
